var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.528326 25.6376C6.90369 26.6184 13.1973 23.1078 15.2407 20.8601C13.1345 15.8377 26.1376 3.63922 17.5554 3.63875C15.5709 3.63875 13.876 -1.55973 6.65848 2.34299C6.63248 3.92069 6.65848 9.3819 6.65848 10.3117C6.65848 23.185 -0.697706 24.8979 0.528326 25.6376Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCorner);
export default __webpack_public_path__ + "static/media/message-corner.63a7ac6e5620e87894cb6978051274f6.svg";
export { ForwardRef as ReactComponent };